import { render, staticRenderFns } from "./pago-contribuciones-diferidas.vue?vue&type=template&id=d0c7781e&lang=html&"
import script from "./pago-contribuciones-diferidas.vue?vue&type=script&lang=js&"
export * from "./pago-contribuciones-diferidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports